import { Box } from "@mui/material";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { InteractiveAvatarTextInput } from "../../InteractiveAvatarTextInput";
import AvatarChatHistory, {
  IAvatarChatHistoryMessage
} from "../AvatarChatHistory/AvatarChatHistory";

interface IAvatarChatBoxProps {
  messages: IAvatarChatHistoryMessage[];
  disabled?: boolean;
  loading?: boolean;
  text: string;
  setText: (value: string) => void;
  handleSpeak: () => void;
  handleOpenSummary: () => void;
  handleRecord: (blob: Blob) => void;
  audioBlob?: Blob | null;
  handleDeleteAudio: () => void;
}

const AvatarChatBox = ({
  messages,
  disabled = false,
  loading = false,
  text,
  setText,
  handleSpeak,
  handleOpenSummary,
  handleRecord,
  audioBlob,
  handleDeleteAudio
}: IAvatarChatBoxProps) => {
  const { t } = useTranslation();
  const chatHistoryRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    if (chatHistoryRef.current) {
      chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      }}
    >
      {/* History */}
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          mb: 1
        }}
        ref={chatHistoryRef}
      >
        <AvatarChatHistory messages={messages} />
      </Box>

      {/* Chat input */}
      <Box sx={{ width: "99%" }}>
        <InteractiveAvatarTextInput
          disabled={disabled}
          input={text}
          label="Chat"
          loading={loading}
          placeholder={t("chatbot.actions.interact")}
          setInput={setText}
          onSubmit={handleSpeak}
          handleOpenSummary={handleOpenSummary}
          onRecord={handleRecord}
          audioBlob={audioBlob}
          onDeleteAudio={handleDeleteAudio}
        />
      </Box>
    </Box>
  );
};

export default AvatarChatBox;
